import { LicenseType, userRole } from "src/app/IntEnums.enum";
import { ORG_Account_Info_DTO } from "./ORG_Account_Info_DTO";

 export class UserAuthedDTO {

  DisplayName: string;
  DefualtLanguage: string;
  URole: userRole;
  LastLogin: Date | string;
  Utoken: any;
  ORG_AccountId: number;
  AccountName: string;
  ORG_Account_BranchId: number;
  BranchName: string;
  YearId: number;
  YId: number;
  UId: number;
  YearStart: Date;
  YearEnd: Date;
  ExpiryDate: Date | string;
  LicenseType: LicenseType;
  TenantID:number;
  Permissions: UserPermissions_DTO[]=[];
  Account_Info: ORG_Account_Info_DTO;


}
export class UserPermissions_DTO {
    ModuleId: number;
    IsGranted: boolean;
    PermissionName: string;
}
